import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CollapsibleSection } from '@/shared/components/CollapsibleSection';
import { Field } from '@/shared/components/Field';
import { Select } from '@/shared/components/Select';
import { useSucursales } from '@/data/hooks/useCatalogos';
/**
 * Selector de Sucursal de la reserva. Va arriba porque filtra los catalogos
 * (tarifas, puntos de encuentro, instructores) del resto del form.
 */
export function CardSucursalBanner({ form, disabled, onBlurPersistir }) {
    const { data: sucursales } = useSucursales();
    const errors = form.formState.errors;
    return (_jsx(CollapsibleSection, { titulo: "Sucursal", defaultOpen: true, children: _jsx(Field, { label: "", htmlFor: "sucursalId", error: errors.sucursalId?.message, children: _jsxs(Select, { id: "sucursalId", disabled: disabled, ...form.register('sucursalId', { onBlur: onBlurPersistir }), children: [_jsx("option", { value: "", children: "Seleccion\u00E1\u2026" }), sucursales?.map((s) => (_jsx("option", { value: s.id, children: s.nombre }, s.id)))] }) }) }));
}
